// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"193c605b","488":"d003d5fe","651":"c861cd6a","732":"3ed0f0ef","977":"8339f93d"}[chunkId] + ".chunk.js";
};